import { Button, Checkbox, Col, Dropdown, Form, Menu, message, Modal, Row, Select, Spin, Tag, Tooltip } from "antd"
import QueueAnim from 'rc-queue-anim'
import { DatePickerWithMask, UIPageListing } from "../../components"
import { useEffect, useRef, useState } from "react";
import { companiesService, departmentsService, employeesService, timeCardService } from "../../redux/services";
import { API_ERRO_TYPE_CANCEL } from "../../config/general";
import axios from "axios";
import moment from "moment";
import { connect } from "react-redux";

const config = {
	title: "Assinaturas",
	permissionPrefix: "funcionarios",
};

const Signatures = ({ permissions }) => {
    const axiosCancelCompaniesToken = useRef(null);
    const axiosCancelDepartmentsToken = useRef(null);
    const axiosCancelEmployeesToken = useRef(null);

    const [companiesIsLoading, setCompaniesIsLoading] = useState(false);
    const [companies, setCompanies] = useState([]);
    const [departmentsIsLoading, setDepartmentsIsLoading] = useState(false);
    const [departments, setDepartments] = useState([]);
    const [employeesIsLoading, setEmployeesIsLoading] = useState(false);
    const [employees, setEmployees] = useState([]);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [selectedMap, setSelectedMap] = useState({});
    const [selectedAll, setSelectedAll] = useState(false);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 50 });

    const [form] = Form.useForm();

    const selectedItems = Object.keys(selectedMap).map(Number);
    const selectedUuids = Object.values(selectedMap);
    
    const fetchCompanies = (callback) => {
        if (axiosCancelCompaniesToken.current) {
            axiosCancelCompaniesToken.current.cancel(
                'Only one request allowed at a time.'
            )
        }

        axiosCancelCompaniesToken.current = axios.CancelToken.source()

        setCompaniesIsLoading(true);

        companiesService
            .getAutocomplete({
                orderBy: 'nome:asc',
                ativo: 1,
                cancelToken: axiosCancelCompaniesToken.current.token,
            })
            .then((response) => {
                setCompanies(response.data.data);
                setCompaniesIsLoading(false);
                if (callback) callback(response);
            })
            .catch((data) => {
                if (data.error_type === API_ERRO_TYPE_CANCEL) return null

                setCompaniesIsLoading(false);

                Modal.error({
                    title: 'Ocorreu um erro!',
                    content: String(data),
                })
            })
    }

    const fetchDepartments = (value) => {
        if (axiosCancelDepartmentsToken.current) {
            axiosCancelDepartmentsToken.current.cancel(
                'Only one request allowed at a time.'
            );
        }

        axiosCancelDepartmentsToken.current = axios.CancelToken.source()

        setDepartmentsIsLoading(true);

        let params = {
        search: value,
        is_active: 1,
        orderBy: 'nome:asc',
        cancelToken: axiosCancelDepartmentsToken.current.token,
        empresas_ids: form.getFieldValue('empresas').includes('todos')
            ? []
            : form.getFieldValue('empresas'),
        }

        departmentsService
            .getAutocomplete({
                ...params,
            })
            .then((response) => {
                setDepartmentsIsLoading(false);
                setDepartments(response.data.data);
            })
            .catch((data) => {
                if (data.error_type === API_ERRO_TYPE_CANCEL) return null

                setDepartmentsIsLoading(false);

                Modal.error({
                    title: 'Ocorreu um erro!',
                    content: String(data),
                })
            })
    }

    const fetchEmployees = (value) => {
        if (axiosCancelEmployeesToken.current) {
            axiosCancelEmployeesToken.current.cancel(
                'Only one request allowed at a time.'
            );
        }

        axiosCancelEmployeesToken.current = axios.CancelToken.source()

        setEmployeesIsLoading(true);

        let params = {
        search: value,
        ativo: 1,
        orderBy: 'nome:asc',
        cancelToken: axiosCancelEmployeesToken.current.token,
        empresas_ids: form.getFieldValue('empresas').includes('todos')
            ? []
            : form.getFieldValue('empresas'),
        departamentos_ids: form
            .getFieldValue('departamentos')
            .includes('todos')
            ? []
            : form.getFieldValue('departamentos'),
        }

        employeesService
            .getAutocomplete({
                ...params,
            })
            .then((response) => {
                setEmployeesIsLoading(false);
                setEmployees(response.data.data);
            })
            .catch((data) => {
                if (data.error_type === API_ERRO_TYPE_CANCEL) return null

                setEmployeesIsLoading(false);

                Modal.error({
                    title: 'Ocorreu um erro!',
                    content: String(data),
                })
            })
    }

    const onCompanyChange = (value) => {
        if (value?.length > 1 && value.includes('todos')) {
            form.setFieldValue(
                'empresas',
                value.filter((item) => item !== 'todos')
            )
        }

        setEmployees([]);
        setEmployeesIsLoading(false);
        setDepartments([]);
        setDepartmentsIsLoading(false);

        fetchDepartments('');
        fetchEmployees('');

        console.log('form', form);
        form.setFieldValue("departamentos", ["todos"]);
        form.setFieldValue("funcionarios", ["todos"]);
    }

    const onCompanySelect = (value) => {
        if (value === 'todos') {
            form.setFieldValue('empresas', ['todos'])
        }
    }

    const onDepartmentChange = (value) => {
        if (value?.length > 1 && value.includes('todos')) {
            form.setFieldValue(
                'departamentos',
                value.filter((item) => item !== 'todos')
            );
        }
    }

    const onDepartmentSelect = (value) => {
        if (value === 'todos') {
            form.setFieldValue('departamentos', ['todos']);
        }
    }

    const onEmployeeChange = (value) => {
        if (value?.length > 1 && value.includes('todos')) {
            form.setFieldValue(
                'funcionarios',
                value.filter((item) => item !== 'todos')
            );
        }
    }

    const onEmployeeSelect = (value) => {
        if (value === 'todos') {
            form.setFieldValue('funcionarios', ['todos']);
        }
    }

    const onFinish = () => {
        fetchData();
    }

    const fetchData = (paginationObject) => {
        setLoading(true);

        const { current, pageSize } = paginationObject || pagination;
        const { empresas, departamentos, funcionarios, data_inicio, data_fim, status } = form.getFieldsValue();

        if (!data_inicio) {}

        const payload = {
            paginacao: pageSize,
            page: current,
        }

        payload.data_inicio = data_inicio ? moment(data_inicio).format('YYYY-MM-DD') : moment().startOf('month').format('YYYY-MM-DD');
        payload.data_fim = moment(data_fim).format('YYYY-MM-DD');

        if (empresas?.length > 0 && !empresas.includes('todos')) {
            payload.empresa_ids = empresas;
        }

        if (departamentos?.length > 0 && !departamentos.includes('todos')) {
            payload.departamento_ids = departamentos;
        }

        if (funcionarios?.length > 0 && !funcionarios.includes('todos')) {
            payload.funcionario_ids = funcionarios;
        }

        if (status !== 'todos') {
            payload.status = status;
        }

        timeCardService.listarCartoesAssinados(payload)
            .then(({ data }) => {
                setData(data.data);
                setPagination({
                    ...pagination,
                    total: data.total,
                    current,
                    pageSize,
                })

                if (data.data.length < 1) {
                    setSelectedAll(false);
                }

                if (selectedAll) {
                    setSelectedMap(prev => {
                        const newState = { ...prev };

                        data.data.forEach(item => {
                            if (item.uuid) {
                                newState[item.id] = item.uuid;
                            }
                        });

                        return newState;
                    });
                }
                setLoading(false);
            }).catch((data) => {
                console.log('error', data);
                message.error('Ocorreu um erro ao listar as assinaturas, tente novamente!');
                setLoading(false);
            });
    }

	const onPaginationChange = (page, pageSize) => {
        const newPaginationObject = {
            ...pagination,
            current: page,
            pageSize,
        }
        setPagination(newPaginationObject);
        fetchData(newPaginationObject);
	};

    const cancelSignature = (solicitacao_id, funcionario_id) => {
        setLoading(true);

        timeCardService.cancelarSolicitacaoAssinatura({
            solicitacao_id,
            funcionario_id,
        }).then(({ data }) => {
            setLoading(false);
            message.success('Assinatura cancelada!');
            fetchData(pagination);
        }).catch((data) => {
            Modal.error({
                title  : "Ocorreu um erro!",
                content: String(error),
            });
            setLoading(false);
        });
    }

    const cancelConfirm = ({ id, funcionario_id }) => {
        Modal.confirm({
            title: "Confirmar cancelamento!",
            content: "Tem certeza de que deseja cancelar esta assinatura?",
            okText: "Continuar",
            autoFocusButton: null,
            onOk: () => {
                return cancelSignature(id, funcionario_id);
            }
        });
    };

    const cancelMultipleSignature = () => {
        setLoading(true);

        const payload = {
            cancelAllFiltered: selectedAll,
        };

        if (selectedAll) {
            const { empresas, departamentos, funcionarios, data_inicio, data_fim, status } = form.getFieldsValue();

            payload.data_inicio = moment(data_inicio).format('YYYY-MM-DD');
            payload.data_fim = moment(data_fim).format('YYYY-MM-DD');

            if (empresas?.length > 0 && !empresas.includes('todos')) {
                payload.empresa_ids = empresas;
            }

            if (departamentos?.length > 0 && !departamentos.includes('todos')) {
                payload.departamento_ids = departamentos;
            }

            if (funcionarios?.length > 0 && !funcionarios.includes('todos')) {
                payload.funcionario_ids = funcionarios;
            }

            if (status !== 'todos') {
                payload.status = status;
            }
        } else {
            payload.uuids = selectedUuids;
        }

        timeCardService.cancelarMultiplasSolicitacaoAssinatura(payload).then(({ data }) => {
            setLoading(false);
            message.success('Assinatura(s) cancelada(s)!');
            fetchData(pagination);
            setSelectedMap({});
            setSelectedAll(false);
        }).catch((data) => {
            Modal.error({
                title  : "Ocorreu um erro!",
                content: String(error),
            });
            setLoading(false);
        });
    }

    const cancelMultipleConfirm = () => {
        Modal.confirm({
            title: "Confirmar cancelamento!",
            content: `Tem certeza de que deseja cancelar ${selectedItems.length} assinatura(s) selecionada(s)?`,
            okText: "Sim",
            cancelText: "Não",
            autoFocusButton: null,
            onOk: () => {
                return cancelMultipleSignature();
            }
        });
    };

    const deleteSignature = (uuid) => {
        setLoading(true);

        timeCardService.excluirSolicitacaoAssinatura({
            uuid,
        }).then(({ data }) => {
            setLoading(false);
            message.success('Assinatura excluida!');
            fetchData(pagination);
        }).catch((data) => {
            Modal.error({
                title  : "Ocorreu um erro!",
                content: String(data),
            });
            setLoading(false);
        });
    }

    const deleteConfirm = ({ uuid }) => {
        Modal.confirm({
            title: "Confirmar exclusão!",
            content: "Tem certeza de que deseja excluir este registro?",
            okText: "Excluir",
            autoFocusButton: null,
            onOk: () => {
                return deleteSignature(uuid);
            }
        });
    };

    const deleteMultipleSignature = () => {
        setLoading(true);
        const payload = {
            deleteAllFiltered: selectedAll,
        };

        if (selectedAll) {
            const { empresas, departamentos, funcionarios, data_inicio, data_fim, status } = form.getFieldsValue();

            payload.data_inicio = moment(data_inicio).format('YYYY-MM-DD');
            payload.data_fim = moment(data_fim).format('YYYY-MM-DD');

            if (empresas?.length > 0 && !empresas.includes('todos')) {
                payload.empresa_ids = empresas;
            }

            if (departamentos?.length > 0 && !departamentos.includes('todos')) {
                payload.departamento_ids = departamentos;
            }

            if (funcionarios?.length > 0 && !funcionarios.includes('todos')) {
                payload.funcionario_ids = funcionarios;
            }

            if (status !== 'todos') {
                payload.status = status;
            }
        } else {
            payload.uuids = selectedUuids;
        }


        timeCardService.excluirMultiplasSolicitacaoAssinatura(payload).then(({ data }) => {
            setLoading(false);
            message.success('Assinatura(s) excluida(s)!');
            fetchData(pagination);
            setSelectedMap({});
            setSelectedAll(false);
        }).catch((data) => {
            Modal.error({
                title  : "Ocorreu um erro!",
                content: String(data),
            });
            setLoading(false);
        });
    }

    const dowloadCartoesAssinados = async () => {
        setLoading(true);
        const payload = {
            dowloadAllFiltered: selectedAll,
        };

        if (selectedAll) {
            const { empresas, departamentos, funcionarios, data_inicio, data_fim, status } = form.getFieldsValue();

            payload.data_inicio = moment(data_inicio).format('YYYY-MM-DD');
            payload.data_fim = moment(data_fim).format('YYYY-MM-DD');

            if (empresas?.length > 0 && !empresas.includes('todos')) {
                payload.empresa_ids = empresas;
            }

            if (departamentos?.length > 0 && !departamentos.includes('todos')) {
                payload.departamento_ids = departamentos;
            }

            if (funcionarios?.length > 0 && !funcionarios.includes('todos')) {
                payload.funcionario_ids = funcionarios;
            }

            if (status !== 'todos') {
                payload.status = status;
            }
        } else {
            payload.uuids = selectedUuids;
        }

        try {
            const response = await timeCardService.dowloadCartoesAssinados(payload);

            const { data } = response;

            const url = window.URL.createObjectURL(new Blob([data]));

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `cartoes_ponto_${moment().format('DD/MM/YYYY_HH:mm')}.zip`); // nome do arquivo
            document.body.appendChild(link);
            link.click();

            link.remove();
            setLoading(false);

        } catch (error) {
            console.log(error.error)
            if (error.error.response && error.error.response.data instanceof Blob) {
                const reader = new FileReader();

                reader.onload = () => {
                    try {
                        const errorData = JSON.parse(reader.result);
                        console.error("Mensagem do servidor:", errorData.message);

                        Modal.error({
                            title  : "Ocorreu um erro!",
                            content: String(errorData.message),
                        });
                    } catch (e) {
                        console.error("Erro ao processar JSON de erro", e);
                    }
                };

                reader.readAsText(error.error.response.data);
            } else {
                Modal.error({
                    title  : "Ocorreu um erro!",
                    content: String(error.message),
                });
            }

            setLoading(false);
        }
    }


    const deleteMultipleConfirm = () => {
        Modal.confirm({
            title: "Confirmar exclusão!",
            content: `Tem certeza de que deseja excluir ${selectedItems.length} assinatura(s) selecionada(s)?`,
            okText: "Sim",
            cancelText: "Não",
            autoFocusButton: null,
            onOk: () => {
                return deleteMultipleSignature();
            }
        });
    };

    const selectItem = ({ id, uuid }) => {
        if (!uuid) {
            console.warn('Item sem UUID:', id);
            return;
        }

        setSelectedMap(prev => {
            const newState = { ...prev };

            if (newState[id]) {
                delete newState[id];
                setSelectedAll(false);
            } else {
                newState[id] = uuid;
            }

            return newState;
        });
    };

    const selectAll = (event) => {
        const isChecked = event.target.checked;

        if (isChecked) {
            setSelectedAll(true);

            setSelectedMap(prev => {
                const newState = { ...prev };

                data.forEach(item => {
                    if (item.uuid) {
                        newState[item.id] = item.uuid;
                    }
                });

                return newState;
            });
        } else {
            setSelectedAll(false);
            setSelectedMap({});
        }
    };

    useEffect(() => {
        fetchCompanies(() => {
            fetchDepartments('');
            fetchEmployees('');
        });
        fetchData(pagination);
    }, []);

    const statusTipo = {
        signed: { title: 'Assinado', color: '#0acf97' },
        pending: { title: 'Pendente', color: '#FFC857' },
        canceled: { title: 'Cancelada', color: '#fa5c7c' },
    }

    const columns = [
        {
            title: 'Empresa',
            render: (item) => <div>{item.contrato?.empresa?.nome}</div>
        },
                {
            title: 'Departamento',
            render: (item) => <div>{item.contrato?.departamento?.nome}</div>
        },
                {
            title: 'Funcionário',
            ellipsis: true,
            render: (item) => <div>{item.contrato?.funcionario?.nome}</div>
        },
        {
            title: 'Data Início',
            render: (item) => <div>{moment(item.data_inicio).format("DD/MM/YYYY")}</div>
        },
        {
            title: 'Data Fim',
            render: (item) => <div>{moment(item.data_fim).format("DD/MM/YYYY")}</div>
        },
        {
            title: 'Status',
            render: ({ status_assinatura }) =>
                <Tag color={statusTipo[status_assinatura].color}>
                    {statusTipo[status_assinatura].title}
                </Tag>
        },
        {
            title: 'Data Assinatura',
            render: (item) => <div>{item.assinado_em ? moment(item.assinado_em).format("DD/MM/YYYY HH:mm") : "-"}</div>
        },
        {
            title: "Ações",
            className: "actions no-ellipsis",
            visible: permissions.includes(config.permissionPrefix + ".show") || permissions.includes(config.permissionPrefix + ".edit") || permissions.includes(config.permissionPrefix + ".delete"),
            render: (item) => (
                <Dropdown overlay={menuItem(item)} className="actions-dropdown" placement="bottomRight" trigger={["click"]}>
                    <Button icon={<i className="fal fa-ellipsis-v" />} />
                </Dropdown>
            ),
        },
    ];

    const menuItem = (item) => (
		<Menu className="actions-dropdown-menu">
			{(item.assinado_em && permissions.includes(config.permissionPrefix + ".show")) && <Menu.Item key="show">
				<a href={item.url_pdf}>
					<i className="fal fa-file" />Baixar PDF
				</a>
			</Menu.Item>}
			{(!item.assinado_em && permissions.includes(config.permissionPrefix + ".edit")) && <Menu.Item key="edit">
				<a onClick={() => cancelConfirm(item)}>
					<i className="fal fa-ban" />Cancelar
				</a>
			</Menu.Item>}
			{permissions.includes(config.permissionPrefix + ".delete") && <Menu.Item key="delete" className="divider btn-delete">
				<a onClick={() => deleteConfirm(item)}>
					<i className="fal fa-trash" />Excluir
				</a>
			</Menu.Item>}
		</Menu>
	);

    const totalSelectedItems = selectedAll ? pagination.total : selectedItems.length;

    return (
      <QueueAnim className="site-content-inner alternative-wrapper">
        <div className="page-content fixed-header signatures-list" key="1">
            <h1 className="page-title">Assinaturas de Cartão Ponto</h1>
            <Form
                form={form}
                layout="vertical"
                scrollToFirstError
                onFinish={onFinish}
                className="form-signatures-list"
                initialValues={{
                required: true,
                empresas: ['todos'],
                departamentos: ['todos'],
                funcionarios: ['todos'],
                data_inicio: moment().startOf('month'),
                data_fim: moment(),
                status: 'todos',
                }}
            >
                <Row gutter={16} align="middle">
                <Col xs={24} md={8}>
                    <Form.Item
                    name="empresas"
                    label="Empresa"
                    hasFeedback
                    rules={[{ required: true, message: 'Campo obrigatório.' }]}
                    >
                    <Select
                        mode="multiple"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                        (typeof option.children === 'string'
                            ? option.children
                            : option.children.props.children
                        )
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        allowClear
                        placeholder="Selecione a(s) empresa(s)"
                        notFoundContent={
                        companiesIsLoading ? (
                            <Spin
                            indicator={
                                <i className="fad fa-spinner-third fa-spin" />
                            }
                            />
                        ) : null
                        }
                        onChange={onCompanyChange}
                        onSelect={onCompanySelect}
                        showSearch
                    >
                        <Select.Option value="todos">Todas</Select.Option>
                        {companies.map((item, index) => (
                        <Select.Option key={index} value={item.id}>
                            {item.nome}
                        </Select.Option>
                        ))}
                    </Select>
                    </Form.Item>
                </Col>
                <Col xs={24} md={8}>
                    <Form.Item
                    name="departamentos"
                    label="Departamento"
                    hasFeedback
                    rules={[{ required: true, message: 'Campo obrigatório.' }]}
                    >
                    <Select
                        mode="multiple"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                        (typeof option.children === 'string'
                            ? option.children
                            : option.children.props.children
                        )
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        allowClear
                        placeholder="Selecione o(s) departamento(s)"
                        notFoundContent={
                        departmentsIsLoading ? (
                            <Spin
                            indicator={
                                <i className="fad fa-spinner-third fa-spin" />
                            }
                            />
                        ) : null
                        }
                        onSearch={fetchDepartments}
                        onChange={onDepartmentChange}
                        onSelect={onDepartmentSelect}
                        showSearch
                    >
                        <Select.Option value="todos">Todos</Select.Option>
                        {departments.map((item, index) => (
                        <Select.Option key={index} value={item.id}>
                            {item.nome}
                        </Select.Option>
                        ))}
                    </Select>
                    </Form.Item>
                </Col>
                <Col xs={24} md={8}>
                    <Form.Item
                    name="funcionarios"
                    label="Funcionário"
                    hasFeedback
                    rules={[{ required: true, message: 'Campo obrigatório.' }]}
                    >
                    <Select
                        mode="multiple"
                        filterOption={false}
                        allowClear
                        placeholder="Selecione o(s) funcionário(s)"
                        notFoundContent={
                        employeesIsLoading ? (
                            <Spin
                            indicator={
                                <i className="fad fa-spinner-third fa-spin" />
                            }
                            />
                        ) : null
                        }
                        onSearch={fetchEmployees}
                        onChange={onEmployeeChange}
                        onSelect={onEmployeeSelect}
                        showSearch
                    >
                        <Select.Option value="todos">Todos</Select.Option>
                        {employees.map((item, index) => (
                        <Select.Option key={index} value={item.id}>
                            {item.nome}
                        </Select.Option>
                        ))}
                    </Select>
                    </Form.Item>
                </Col>
                <Col xs={24} md={12} lg={4} xxl={4}>
                    <DatePickerWithMask
                    onKeyUp={(e) => {
                        if (e.keyCode === 13 || e.keyCode === 9) {
                        form.data_fim.focus()
                        }
                    }}
                    label="Data Início"
                    name="data_inicio"
                    required={true}
                    rules={[
                        {
                        required: true,
                        message: 'Campo obrigatório.',
                        },
                        {
                        validator: async (_, data_inicio) => {
                            var data_fim = form.getFieldValue('data_fim')
                            if (data_fim !== null) {
                            if (data_inicio > data_fim) {
                                return Promise.reject(
                                'A data inicial deve ser menor ou igual a data final.'
                                )
                            }
                            }
                        },
                        },
                    ]}
                    />
                </Col>
                <Col xs={24} md={12} lg={4} xxl={4}>
                    <DatePickerWithMask
                    label="Data Fim"
                    name="data_fim"
                    onKeyUp={(e) => {
                        if (e.keyCode === 13 || e.keyCode === 9) {
                        form.data_inicio.focus()
                        }
                    }}
                    required={true}
                    rules={[
                        {
                        required: true,
                        message: 'Campo obrigatório.',
                        },
                        {
                        validator: async (_, data_fim) => {
                            var data_inicio = form.getFieldValue('data_inicio')
                            if (data_inicio !== null) {
                            if (data_fim < data_inicio) {
                                return Promise.reject(
                                'A data final deve ser maior ou igual a data inicial.'
                                )
                            }
                            }
                        },
                        },
                    ]}
                    />
                </Col>
                <Col xs={24} md={12} lg={4} xxl={4}>
                    <Form.Item
                    name="status"
                    label="Status"
                    hasFeedback
                    >
                    <Select placeholder="Selecione o status">
                        <Select.Option value="todos">Todos</Select.Option>
                        {['signed', 'pending', 'canceled'].map((item, index) => (
                        <Select.Option key={index} value={item}>
                            {statusTipo[item].title}
                        </Select.Option>
                        ))}
                    </Select>
                    </Form.Item>
                </Col>
                
                <Row gutter={16} align='middle'>
                    <div>
                    <Button
                        type="primary"
                        htmlType="submit"
                        shape="round"
                        className="btn-save"
                        icon={<i className="far fa-check" />}
                        loading={loading}
                        disabled={loading}
                        style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', marginLeft: 15 }}
                    >
                        Buscar
                    </Button>
                    </div>
                </Row>
                </Row>
            </Form>

            {(permissions.includes(config.permissionPrefix + ".edit") || permissions.includes(config.permissionPrefix + ".edit")) && 
                <div style={{ display: 'flex', justifyContent: 'space-between' }} className="selection-actions">
                    <Checkbox onChange={selectAll} checked={selectedAll}>Selecionar todas</Checkbox>
                    {(selectedItems.length > 0 || selectedAll) && (<div style={{ display: 'flex', alignItems: 'flex-end'}}>
                        <span>{`${totalSelectedItems} ${totalSelectedItems > 1 ? 'itens selecionados' : 'item selecionado'}`}</span>
                        <Button
                            shape="round"
                            className="btn-save"
                            size="small"
                            icon={<i className="fas fa-download" />}
                            // loading={loading}
                            onClick={() => dowloadCartoesAssinados()}
                            disabled={loading}
                            style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', marginLeft: 15 }}
                        >
                            Baixar Assinados
                        </Button>
                        <Button
                            shape="round"
                            className="btn-save"
                            size="small"
                            icon={<i className="far fa-ban" />}
                            // loading={loading}
                            onClick={() => cancelMultipleConfirm()}
                            disabled={loading}
                            style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', marginLeft: 15 }}
                        >
                            Cancelar
                        </Button>
                        <Button
                            shape="round"
                            className="btn-save"
                            size="small"
                            icon={<i className="far fa-trash" />}
                            // loading={loading}
                            disabled={loading}
                            onClick={() => deleteMultipleConfirm()}
                            style={{ overflow: 'hidden', color: 'red', borderColor: 'red', whiteSpace: 'nowrap', textOverflow: 'ellipsis', marginLeft: 15 }}
                        >
                            Apagar
                        </Button>
                    </div>)} 
                </div>
            }
            <UIPageListing
                isLoading={loading}
                listType="list"
                data={data}
                enableSearch={false}
                showListTypeChange={false}
                pagination={pagination}
                columns={columns}
                showFilters={false}
                allowSelect
                selectedItems={selectedItems}
                onSelectItem={selectItem}
                onPaginationChange={onPaginationChange}
            />
        </div>
      </QueueAnim>
    )
}

const mapStateToProps = (state, ownProps) => {
	return {
		permissions: state.auth.userData.permissions,
		listType: state.general.listType[config.list],
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		onChangeListType: (type) => {
			dispatch(generalActions.changeListType(config.list, type));
		}
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(Signatures);